var a=[" ","\n","\r","\t","\f","\v"," "," ","᠎"," "," "," "," "," "," "," "," "," "," "," ","\u2028","\u2029"," "," ","　"];export{a as default};
//# sourceMappingURL=whitespaces.mjs.map
